import classNames from 'classnames';
import React, {
    Children,
    cloneElement,
    isValidElement,
    ReactNode,
    ReactElement,
    CSSProperties,
    FC,
} from 'react';
import styled, { Interpolation } from 'styled-components';

import { TabProps } from './Tab';

export interface TabsProps {
    value: any;
    name?: string;
    // eslint-disable-next-line no-unused-vars
    onChange?: (value: any, name: string | undefined) => void;
    children: ReactNode;
    className?: string;
    styles?: Interpolation<CSSProperties>;
    disabled?: boolean;
}

const StyledTabs = styled.div<{ styles?: Interpolation<CSSProperties> }>`
    display: flex;
    align-items: center;
    padding: 0 16px;
    & > .tab:not(:last-of-type) {
        margin-right: 16px;
    }
    ${({ styles }) => styles};
`;

const Tabs: FC<TabsProps> = ({
    value,
    name,
    children,
    onChange,
    className,
    styles,
    disabled = false,
}) => {
    const handleChange = (v: any) => {
        if (disabled) return;

        onChange && onChange(v, name);
    };

    return (
        <StyledTabs styles={styles} className={classNames('tabs', className)}>
            {Children.map(children, (child) => {
                if (isValidElement(child)) {
                    return cloneElement(child as ReactElement<TabProps>, {
                        active: child.props.value === value,
                        onClick: handleChange,
                        className: disabled ? 'clickable-disabled' : 'clickable',
                    });
                }
                return child;
            })}
        </StyledTabs>
    );
};

export default Tabs;
